import * as Locales from './locales'

const messages = Object.keys(Locales).reduce(
  (r, lang) => ({
    ...r,
    [lang]: {
      ...Locales[lang],
    },
  }),
  {}
)

export default messages
